// extracted by mini-css-extract-plugin
export default {"root":"ListItem_root__2GRQ6","title":"ListItem_title__yhFDP","info":"ListItem_info__+UkUZ","links":"ListItem_links__5x46Q","itemStyle":"ListItem_itemStyle__P--ew"};